import { apiService } from "@/_services";
/**
 * Get suppliers for all companies
 * @param { object } companies initial company information
 */
export function getProviders(companies) {
  let supplier = [];
  companies.forEach(function(comp) {
    comp["portfolios"].forEach(function(port) {
      supplier = supplier.concat(port["fk_id_provider"]);
    });
  });
  let params = {
    method: "GET",
    endpoint: "providers",
    query_params: {
      format: "json",
      providers: { id: supplier }
    }
  };
  return apiService.getAll(params);
}
